<template>
  <div v-loading="loading" element-loading-text="加载中..." class="app-container">
    <el-card :body-style="{ padding: 0 }" shadow="never" class="sticky-container">
      <template slot="header">
        <el-row class="filter-container">
          <el-col :span="24">
            <el-button class="filter-item" type="danger" icon="el-icon-edit" @click="handleCreate">增加分类</el-button>
          </el-col>
        </el-row>
      </template>

      <el-table v-sticky-header stripe fit highlight-current-row :data="list" row-key="id" header-cell-class-name="table-header-cell">
        <el-table-column label="序号" width="60" align="center" type="index" fixed="left" />
        <el-table-column label="分类名称" prop="name" min-width="150">
          <template slot-scope="{row}">
            <span style="font-weight: 600;" :style="{ color: row.color }">{{ row.name }}</span>
          </template>"
        </el-table-column>
        <el-table-column label="所属商城" width="100" align="center">
          <template slot-scope="{row}">
            <span>{{ getMallType(row.mallType) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="在首页显示" width="100" align="center">
          <template slot-scope="{row}">
            <el-tag :type="row.showInHome === 1 ? 'success' : 'info'" effect="dark">{{ row.showInHome === 1 ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="sortOrder" width="60" align="center" />
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="{row}">
            <el-tag :type="row.status === 1 ? 'success' : 'info'" effect="dark">{{ row.status === 1 ? '启用' : '禁用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="230">
          <template slot-scope="{row}">
            <el-button type="text" size="small" icon="el-icon-plus" @click="handleCreate(row)">添加下级分类</el-button>
            <el-button type="text" size="small" icon="el-icon-edit" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" size="small" icon="el-icon-delete" @click="handleRemove(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="dialogFormTitle" :visible.sync="dialogFormVisible" width="500px" :fullscreen="device==='mobile'">
      <el-form ref="dataForm" :rules="rules" :model="detail" label-width="90px" style="padding: 0 25px;">
        <el-form-item label="上级分类" prop="parentId">
          <el-cascader
            v-model="detail.parentId"
            :options="categories"
            :props="{ value: 'id', label: 'name', checkStrictly: true }"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="detail.name" placeholder="请输入分类名称" clearable />
        </el-form-item>
        <el-form-item label="所属商城">
          <el-select v-model="detail.mallType" placeholder="请选择商城">
            <el-option v-for="(item, index) in mallTypes" :key="index" :label="item" :value="index" />
          </el-select>
        </el-form-item>

        <el-row type="flex" justify="space-between">
          <el-col>
            <el-form-item label="字体颜色">
              <el-color-picker v-model="detail.color" />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="排序">
              <el-input v-model="detail.sortOrder" class="max-width" placeholder="请输入排列顺序" type="number" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="在首页显示">
              <el-switch v-model="detail.showInHome" :width="60" class="rectangle" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="启用">
              <el-switch v-model="detail.status" :width="60" class="rectangle" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template slot="footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">提交保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getCategories, saveCategory, removeCategory } from '@/api/goods'
import { StickyHeader } from '@cell-x/el-table-sticky'
import { mapState } from 'vuex'

export default {
  name: 'Category',
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      categories: [],
      dialogFormTitle: '',
      dialogFormVisible: false,
      detail: {},
      rules: {
        parentId: [{ required: true, message: '请选择上级分类', trigger: 'change' }],
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device,
      mallTypes: state => ['所有商城'].concat(state.base.mallTypes)
    })
  },
  created() {
    this.fetchData()
  },
  methods: {
    getMallType(index) {
      return this.mallTypes[index]
    },
    fetchData() {
      this.loading = true
      getCategories().then(response => {
        // console.log(response)
        this.list = response
        this.categories = [{ id: '0', name: '系统分类', children: response }]
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        setTimeout(() => { this.loading = false }, 500)
      })
    },
    resetDetail(level = 1, parentId = '0') {
      this.detail = Object.assign({}, {
        id: '0',
        logo: '',
        level: level,
        name: '',
        parentId: parentId,
        sortOrder: 0,
        showInHome: 0,
        color: '',
        status: 1,
        mallType: 0
      })
    },
    handleCreate(item) {
      this.resetDetail()
      if (item && item.id) {
        this.detail.parentId = item.id
        this.detail.level = item.level + 1
        this.detail.sortOrder = item.children ? (item.children.length + 1) : 1
      } else {
        this.detail.sortOrder = this.list ? (this.list.length + 1) : 1
      }

      this.dialogFormTitle = '新增分类'
      this.dialogFormVisible = true
    },
    handleEdit(item) {
      console.log(item)
      this.detail = item
      this.dialogFormTitle = '编辑分类'
      this.dialogFormVisible = true
    },
    handleRemove(item) {
      if (item.children && item.children.length) {
        return this.$message.warning('该分类下有子分类，请先删除子分类')
      }

      this.loading = true
      removeCategory(item).then(response => {
        this.list = response
        this.categories = [{ id: '0', name: '根分类', children: response }]
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        setTimeout(() => { this.loading = false }, 500)
      })
    },
    handleSubmit() {
      if (!this.detail.parentId) this.detail.parentId = '0'

      this.loading = true
      if (Object.keys(this.detail).includes('children')) delete this.detail.children

      // console.log('handleSubmit', this.detail)
      saveCategory(this.detail).then(response => {
        this.list = response
        this.categories = [{ id: '0', name: '根分类', children: response }]
        setTimeout(() => { this.loading = false; this.dialogFormVisible = false }, 500)
      }).catch(err => {
        console.error(err)
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card__header {
    padding-bottom: 0;
  }
  .el-dialog__body {
    padding-bottom: 0;
  }
}
</style>
